/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import HeadPage from "pages/StepPages/StepFour/HeadPage";
import sass from "./register.module.sass";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import DropMenu from "pages/StepPages/StepFour/One/Tables/TableNavigate/DropMenu";
import { ReactComponent as ActionMenuEdit } from "images/EditorIcon.svg";
import { ReactComponent as PlusIcon } from "images/PlusIcon.svg";
import { ReactComponent as RemoveIcon } from "images/TrashCan.svg";
import Badge from "components-new/Badge";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { IBPClass } from "pages/References/BusinessProcessRegistry/model";
import {
	ConfirmArchiveTemplate,
	ConfirmRemoveRow,
	Modal,
} from "pages/References/BusinessProcessRegistry/ItemBuisnesTemplate/Modals";
import ItemTable from "pages/References/BusinessProcessRegistry/ItemBuisnesTemplate/ItemTable";
import { snackWrapper } from "helpers";
import { organizationAPI } from "libs/apiClient/Organization";
import { BusinessProcessPatternResponse } from "libs/apiClient/data-contracts";
import { userAPI } from "libs/apiClient/User";

// TODO: Все поменять
// TODO: Поменять модели переделать запросы

export interface IBusinessProcessAdded {
	consequenceDescr: string;
	clazz: number;
	criticality: boolean;
	defense: boolean;
	ecologic: boolean;
	economic: boolean;
	name: string;
	politic: boolean;
	reason: string;
	sequenceNumber: string;
	shortDescription: string;
	social: boolean;
	patternId?: number;
}

interface BpPattern {
	id: number;
	name: string;
}

interface Clazz {
	id: number;
	name: string;
	bpCount: number;
}
interface Field {
	patternItemId: number;
	bpPattern: BpPattern;
	clazz: Clazz;
	name: string;
	shortDescription: string;
	isSocial: boolean;
	isPolitic: boolean;
	isEconomic: boolean;
	isEcologic: boolean;
	isDefense: boolean;
	reason: string;
	isCriticality: boolean;
	sequenceNumber: string;
}

export interface IRenderData {
	name: string;
	fields: Field[];
}

const ItemBuisnesTemplate = () => {
	const params = useParams();
	const location = useLocation();
	const navigate = useNavigate();

	const [archive, select] = useMemo(() => {
		const archiveLink = /archive\/.$/.test(location.pathname);
		const selectLink = /select\//.test(location.pathname);

		return [archiveLink, selectLink];
	}, [location.pathname]);

	const [data, setData] = useState<BusinessProcessPatternResponse | null>(null);

	const [confirmArchive, setArchiveConfirm] = useState(false);
	const [confirmRemove, setRemoveConfirm] = useState(false);
	const updateData = () => {
		params.templateId && organizationAPI.patternGetDetail(Number(params.templateId)).then(({ data }) => setData(data));
	};
	const [modal, setModal] = useState<{ active: boolean; data: IBusinessProcessAdded | null; loadTemplate?: boolean }>({
		active: false,
		data: null,
		loadTemplate: false,
	});

	const [uploadProcesses, setUploadProcesses] = useState<number[]>([]);

	const [currentBP, setCurrentBP] = useState("");

	const [target, setTarget] = useState<HTMLOrSVGElement | undefined>();

	const toggleTarget = (e: React.MouseEvent<HTMLOrSVGElement>) => {
		e.stopPropagation();
		e && setCurrentBP(e.currentTarget.dataset.id as string);
		target ? setTarget(undefined) : setTarget(e.currentTarget);
	};
	const archiveTemplate = () => {
		data &&
			organizationAPI
				.processesPatternDisableCreate(Number(data.patternId))
				.then(() => {
					snackWrapper("success", "Шаблон помещен в архив");
					setArchiveConfirm(false);
					setCurrentBP("");
					setTarget(undefined);
					navigate(-1);
					updateData();
				})
				.catch(() => {
					setArchiveConfirm(false);
					setCurrentBP("");
					setTarget(undefined);
				});
	};
	const removeItem = () => {
		const current = JSON.parse(currentBP);
		data &&
			organizationAPI
				.processesPatternItemDeleteCreate(current.patternId)
				.then(() => {
					snackWrapper("success", "Запись удалена");
					setArchiveConfirm(false);
					setCurrentBP("");
					setTarget(undefined);
					updateData();
				})
				.catch(() => {
					setArchiveConfirm(false);
					setCurrentBP("");
					setTarget(undefined);
				});
	};

	const render = useMemo(() => {
		let result: IRenderData[] = [];
		if (data) {
			const businessProcesses: IBPClass[] = data.bpItemsIdsList;
			const temp: { [key: string]: any } = {};

			businessProcesses.forEach((_) => {
				if (temp[_.clazz.name]) {
					temp[_.clazz.name].push(_);
				} else {
					temp[_.clazz.name] = [_];
				}
			});
			let tempKey: any;
			for (tempKey in temp) {
				result.push({
					name: tempKey,
					fields: temp[tempKey],
				});
			}
		}
		return result.sort((a, b) => (a.name < b.name ? -1 : 1));
	}, [data]);

	const checkedRow = (id: number) => {
		if (uploadProcesses.includes(id)) {
			setUploadProcesses((prevState) => prevState.filter((_) => _ !== id));
		} else {
			setUploadProcesses((prevState) => [...prevState, id]);
		}
	};

	const save = () => {
		const id = location.state;
		if (id) {
			organizationAPI.processesPatternApplyPatternItemsCreate(id, uploadProcesses).then(() => {
				navigate(-2);
			});
		}
	};

	const menuRef = useRef<any>(null);
	useEffect(() => {
		function handleClickOutside(event: any) {
			if (menuRef.current && target && !menuRef.current.contains(event.target)) {
				setTarget(undefined);
			}
		}
		document.addEventListener("mouseup", handleClickOutside);
		return () => {
			document.removeEventListener("mouseup", handleClickOutside);
		};
	}, [target]);

	useEffect(() => {
		updateData();
		//eslint-disable-next-line
	}, []);
	const [disabled, setDisabled] = useState(false);
	const needRule = useCallback(() => {
		if (disabled) snackWrapper("error", "Не достаточно прав");
	}, [disabled]);
	useEffect(() => {
		userAPI
			.permissionsCheckCreate(0, ["dictionary.business_process_pattern.edit"])
			.then((r) => setDisabled(!r.data.length));
	}, []);
	return (
		<div className={sass.wrapper}>
			{confirmArchive && (
				<ConfirmArchiveTemplate
					cancelWindow={() => {
						setArchiveConfirm(false);
						setCurrentBP("");
					}}
					ok={() => {
						archiveTemplate();
					}}
				/>
			)}
			{confirmRemove && (
				<ConfirmRemoveRow
					remove={() => {
						removeItem();
						setRemoveConfirm(false);
					}}
					cancelWindow={() => {
						setCurrentBP("");
						setRemoveConfirm(false);
					}}
				/>
			)}
			<Modal
				rootFunc={updateData}
				trigger={modal}
				cancelWindow={() => {
					setModal((prevState) => ({ ...prevState, active: false }));
					setCurrentBP("");
				}}
			/>
			<DropMenu ref={menuRef} target={target} click={() => (disabled ? needRule() : removeItem())} clear>
				<p
					className={sass.dropItem}
					onClick={() => {
						if (disabled) {
							needRule();
							return;
						}
						const obj: IBusinessProcessAdded = JSON.parse(currentBP);
						setModal({
							data: {
								...obj,
							},
							active: true,
							loadTemplate: false,
						});
					}}>
					<ActionMenuEdit width={14} className={sass.edit} /> Редактировать
				</p>
				<p className={sass.dropItem} onClick={() => (disabled ? needRule() : setRemoveConfirm(true))}>
					<RemoveIcon width={14} /> Удалить
				</p>
			</DropMenu>
			<HeadPage
				title={
					<p className={sass.headTitle}>
						Шаблон - {data?.name} {archive && <Badge color={"#7CADAA"}>Архив</Badge>}
					</p>
				}
				subTitle={data?.organization?.shortName || ""}>
				<div className={sass.head}>
					{select ? (
						<Button onClick={save}>Сохранить</Button>
					) : (
						!archive && (
							<>
								<Button disabled={disabled} variant={BUTTON_VARIANTS.OUTLINED} onClick={() => setArchiveConfirm(true)}>
									Архивировать шаблон
								</Button>
								<Button disabled={disabled} onClick={() => setModal({ active: true, data: null })}>
									<PlusIcon className={sass.plus} />
									Добавить бизнес-процессы
								</Button>
							</>
						)
					)}
				</div>
			</HeadPage>
			<table className={select ? sass.tableSelect : sass.table}>
				<thead>
					<tr>
						{select && <th />}
						<th>Класс бизнес-процессов</th>
						<th>Бизнес-процессы в деятельности организации</th>
						<th>Краткое описание бизнес-процессов в деятельности организации</th>
						<th>Критерии значимости</th>
						<th>Описание возможных последствий</th>
						<th>Заключение о критичности</th>
						{!select && <th />}
					</tr>
				</thead>
			</table>
			<div data-comment-false={true} className={sass.scroll}>
				<ItemTable
					disabled={disabled}
					rule={needRule}
					data={render}
					select={select}
					checkRow={checkedRow}
					toggle={toggleTarget}
					uploadArr={uploadProcesses}
				/>
			</div>
		</div>
	);
};

export default ItemBuisnesTemplate;
